
import { Component, Vue } from 'vue-property-decorator';
import { ValidationRules } from '@/utils/validation-rules';
import { relationshipTypes } from '@/consts/relationship-types';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { StaffAccessLevels } from "@/enums/StaffAccessLevels";
import ConfirmDlg from '@/components/popup/confirm-dialog/ConfirmDlg.vue';
import AddFamilyMemberDialog from '@/views/family-members/add-family-member-dialog/AddFamilyMemberDialog.vue';

@Component({
  components: {
    ValidationProvider,
    ValidationObserver,
    ConfirmDlg,
    AddFamilyMemberDialog
  }
})
export default class FamilyHubList extends Vue {

  created(){
    this.headers.map(x=>(x.text = this.$i18n.messages[this.$i18n.locale][x.text]  as string))
  }
  
  get resident() {
    return this.$store.state.residentModule.currentResident;
  }

  dialog = false;
  headers = [
    {
      text: 'GeneralTranslations.Name',
      align: 'start',
      sortable: false,
      value: 'name',
    },
    {
      text: 'GeneralTranslations.Email',
      align: 'start',
      sortable: false,
      value: 'email',
    },
    {
      text: 'FamilyHubList.FEPOA',
      align: 'start',
      sortable: false,
      value: 'epoa',
    },
    {
      text: 'GeneralTranslations.Phone',
      align: 'start',
      sortable: false,
      value: 'phoneNumber',
    }
  ];
  submited = false;
  invitedToFamilyApp = false;
  staffAccessLevels = StaffAccessLevels;
  familyHubUsers = this.$store.state.residentModule.currentResident?.familyHubUsers ?? [];

  get rules() {
    return {
      email: [ValidationRules.email, ValidationRules.required],
    };
  }

  get relationshipTypes() {
    return relationshipTypes;
  }

  get facility() {
    return this.$store.state.facilityModule.selectedFacility;
  }

  get user() {
    return this.$store.state.authModule.user;
  }

  get canDelete() {
    if (this.user && this.familyHubUsers?.length) {
      return this.user?.accessLevel === this.staffAccessLevels.OrgAdmin || this.user?.accessLevel === this.staffAccessLevels.HomeAdmin;
    } else {
      return false;
    }
  }

  async familyMembersAdded(){
    await this.$store.dispatch('getResident', this.$store.state.residentModule.currentResident?.id);
    await this.$store.dispatch('getFamilyMembersByResident', { residentId: this.$store.state.residentModule.currentResident?.id });
  }

  deleteFamilyMember(member) {
    (this.$refs.confirmationModal as any)
      .open(
        null,
        this.$i18n.messages[this.$i18n.locale]['FamilyHubList.DeleteMessage'],
        false
      )
      .then(response => {
        if (response && response.agree) { 
          this.familyHubUsers = this.familyHubUsers.filter(x => x.id !== member.id);
          this.$store.dispatch('deleteFamilyHubUserFromResident', {
            familyHubUserId: member.id,
            residentId: this.$store.state.residentModule.currentResident?.id,
            facilityId: this.facility.id,
          }).then(async(x)=>{
            await this.$store.dispatch('getFamilyMembersByResident', { residentId: this.$store.state.residentModule.currentResident?.id });
          });
        }
      });
  }

  isFamilyUserFinancialEPOA(familyMember, resident) {
    if(!resident.id) return false
    
    return (
      familyMember?.financialEPOA?.find(x => x.id === resident.id)?.status ||
      false
    );
  }

  checkAccessLevel() {
    if(this.canDelete) {
      this.headers.push({
        text: '',
        align: 'start',
        sortable: false,
        value: 'id',
      })
    }
  }

  checkAccessLevelOnDestroy() {
    if(this.canDelete) {
      this.headers.pop()
    }
  }

  handleClickFamilyMember(row): void {
    this.$router.push('/family-members/' + row?.id);
  }

  mounted() {
    this.checkAccessLevel();
  }

  $destroy() {
    this.checkAccessLevelOnDestroy();
  }
}
